/*
 * Copyright (c) Dito Technologies LLC
 */

import React, {LegacyRef, MouseEventHandler} from "react";
import classnames from "classnames";
import styles from "ui/feature/piece-play/common/piece-renderer/PieceRendererNote.module.scss";
import {TopPxForNote, widthForWholeNote} from "ui/feature/piece-play/common/piece-renderer/PieceRendererNote";
import {NoteDisplayState} from "ui/feature/piece-play/common/PlayTypes";

interface Props {
    onClick?: MouseEventHandler<HTMLDivElement>;
    dragRef?: LegacyRef<HTMLDivElement>;
    midiNumber: number;
    lineAdjustment?: number;
    noteDuration: number;
    // leftOffset?: number;
    noteStart: number;
    noteState: NoteDisplayState;
    isDragging?: boolean;
    notePitchTitle?: string
}

const PieceRendererNoteDisplay: React.FC<Props> = ({
                                                       onClick,
                                                       midiNumber,
                                                       noteStart,
                                                       lineAdjustment,
                                                       noteDuration,
                                                       // leftOffset,
                                                       dragRef,
                                                       noteState,
                                                       isDragging,
                                                       notePitchTitle
                                                   }) => {

    const top = React.useMemo(() => {
        return TopPxForNote(midiNumber, lineAdjustment);
    }, [midiNumber, lineAdjustment]);

    const width = React.useMemo(() => {
        return noteDuration * widthForWholeNote;
    }, [noteDuration]);

    const left = React.useMemo(() => {
        return (widthForWholeNote * noteStart)
    }, [noteStart]);

    return (
        <div
            ref={dragRef}
            draggable={true}
            onClick={onClick}
            className={classnames(styles.container, {
                [styles.success]: noteState === "success",
                [styles.error]: noteState === "error",
                [styles.current]: noteState === "current",
                [styles.none]: noteState === "none",
                [styles.dragging]: isDragging
            })}
            style={{
                top: `${top}px`,
                width: `${width}px`,
                left: `${left}px`
            }}>
            <b className={styles.notePitchTitle}>{notePitchTitle ?? " "}</b>
        </div>
    )
}

export default PieceRendererNoteDisplay;